<div class="mfa-backdrop">
  <div class="mfa-dialog" role="dialog" aria-modal="true" aria-labelledby="mfa-title" (keydown.escape)="cancel()">
    <h2 id="mfa-title" class="mfa-title">
      {{ translate.instant(enrollment ? 'LOGIN.ktidentity.mfa.enrollTitle' : 'LOGIN.ktidentity.mfa.title') }}
    </h2>

    <ng-container *ngIf="enrollment">
      <p class="mfa-text">{{ translate.instant('LOGIN.ktidentity.mfa.enrollInstructions') }}</p>
      <div class="mfa-qr">
        <img *ngIf="qrDataUrl" [src]="qrDataUrl" width="160" height="160" [alt]="translate.instant('LOGIN.ktidentity.mfa.qrAlt')" />
      </div>
      <p class="mfa-text mfa-text--small">{{ translate.instant('LOGIN.ktidentity.mfa.manualKey') }}</p>
      <div class="mfa-secret">
        <code>{{ challenge.mfa_secret }}</code>
        <button type="button" class="btn btn-link mfa-copy" (click)="copySecret()">
          {{ translate.instant(copied ? 'LOGIN.ktidentity.mfa.copied' : 'LOGIN.ktidentity.mfa.copy') }}
        </button>
      </div>
    </ng-container>

    <p *ngIf="!enrollment" class="mfa-text">{{ translate.instant('LOGIN.ktidentity.mfa.instructions') }}</p>

    <form class="mfa-form" (ngSubmit)="submit()">
      <label for="mfa-code" class="visually-hidden">{{ translate.instant('LOGIN.ktidentity.mfa.codeLabel') }}</label>
      <input #codeInput id="mfa-code" name="mfaCode" class="form-control mfa-code" type="text"
        inputmode="numeric" autocomplete="one-time-code" maxlength="12" placeholder="000000"
        [attr.aria-invalid]="invalidCode" aria-describedby="mfa-error"
        [disabled]="submitting" [ngModel]="code" (ngModelChange)="onCodeChange($event)" />
      <p id="mfa-error" class="mfa-error" role="alert" *ngIf="invalidCode">{{ translate.instant('LOGIN.ktidentity.mfaInvalid') }}</p>

      <div class="mfa-actions">
        <button type="button" class="btn mfa-cancel" (click)="cancel()">{{ translate.instant('LOGIN.ktidentity.mfa.cancel') }}</button>
        <button type="submit" class="btn mfa-confirm" [disabled]="submitting || code.length !== 6">
          {{ translate.instant('LOGIN.ktidentity.mfa.confirm') }}
        </button>
      </div>
    </form>
  </div>
</div>
